import styled from "styled-components";
import { colors } from "../../../../../theme/theme";
import { CardDescription } from "../../styled";

export const CardDescriptionForMedia = styled(CardDescription)`
	padding: 24px;
	padding-left: 32px;
	border-radius: 4px;
	box-shadow: 0px 0px 6px rgba(100, 115, 255, 0.1);
`;

export const CardDescriptionFull = styled(CardDescriptionForMedia)`
	max-height: 100%;
`;

export const ObjectValuesTitle = styled.div`
	font-size: 18px;
	padding-bottom: 10px;
	border-bottom: 1px solid ${colors.greyscale.light_grey};
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const LimitCharacterDiv = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 400px;
	font-size: 14px;
	margin-bottom: 24px;
`;
